import './BargainWarehouse.scss';
import {
  PageTitle,
  LoadingCircle,
  Breadcrumbs,
  PageNotFound,
} from '@gplibraries/react/components';
import { useTokenProvider, useConfig } from '@gplibraries/react/hooks';
import { StringFormatter } from '@gplibraries/utils';
import { useNavigate } from 'react-router';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useParams } from 'react-router';
import { fetchBwPartListing } from '../../api/bargainWarehouse.js';
import PartListing from '../../components/BargainWarehouse/PartListing';

export default function BargainWarehousePartListing() {

  const { dealerAccessApiScope, dealerAccessApiHost } = useConfig();
  const { nid, title } = useParams();
  const navigate = useNavigate();
  const getToken = useTokenProvider({ scopes: [dealerAccessApiScope]});

  // middleware token query
  const { data: token, isLoading: tokenLoading } = useQuery({
    enabled: Boolean(getToken),
    queryKey: ['middlewareToken'],
    queryFn: () => getToken!()
  });

  const { isLoading: fetchLoading, error: fetchError, data: listing } = useQuery({
    enabled: Boolean(token),
    queryKey: ['bargain_warehouse', 'parts', nid],
    queryFn: () => getToken!()
      .then(token => fetchBwPartListing(dealerAccessApiHost, token!.accessToken, nid))
      .then(res => res.json()),
    select: (data) => data.data // only want to work with the data property of the response
  })

  // Add the title segment to the URL if only the NID was provided, and if a
  // title was provided make sure it is correct.
  useEffect(() => {
    if (!listing) return;
    if (!title || title !== StringFormatter.urlSafe(listing.title)) {
      navigate(`/bargain-warehouse/parts/${nid}/${StringFormatter.urlSafe(listing.title)}`, { replace: true })
    }
  }, [title, listing]);

  if (fetchError) throw fetchError;
  if (fetchLoading || tokenLoading) return <LoadingCircle className={'large color'}/>
  if (!fetchLoading && !listing) return <PageNotFound/>

  return (
      <div className={'flex-col full'}>
        <Breadcrumbs breadcrumbs={{
          'Bargain Warehouse': '/bargain-warehouse',
          [listing.title || nid || '']: ''
        }}/>
        <PageTitle>{listing.title}</PageTitle>
        <PartListing part={listing}/>
      </div>
  );
}